import React from 'react';
import {
    Container,
    Grid,
    Typography,
    Paper,
    List,
    ListItem,
    ListItemText,
    ThemeProvider,
    createTheme,
    Box,
    Button,
} from '@mui/material';
import { useAuth } from '../../Auth/AuthProvider';
import { empresaDataAPI, representanteempresaShow } from '../../Conections/EmpresaConection';
import { useNavigate, useParams } from 'react-router-dom';

import CircleIcon from '@mui/icons-material/Circle';
import PersonAddAltIcon from '@mui/icons-material/PersonAddAlt';
import { can } from '../../Conections/LogConections';

// Creamos un tema personalizado
const theme = createTheme();

export default function CompanyPersonInterface() {

    const { getToken, getCompany } = useAuth();
    const goTo = useNavigate();
    const idCompany = useParams();

    const [representativeE, setRepresentativeE] = React.useState(false);
    const [name, setName] = React.useState('');
    const [last, setLast] = React.useState('');
    const [dtype, setDtype] = React.useState('');
    const [dnumber, setDnumber] = React.useState('');
    const [editRepPermitido, setEditRepPermitido] = React.useState(false);

    const [company, setCompany] = React.useState('');
    const [cnumber, setCnumber] = React.useState('');
    const [address, setAddress] = React.useState('');
    const [phone, setPhone] = React.useState('');
    const [web, setWeb] = React.useState('');
    const [email, setEmail] = React.useState('');
    const [description, setDescription] = React.useState('');
    const [logo, setLogo] = React.useState('');

    const [ccolor, setCcolor] = React.useState(
        <CircleIcon sx={{ color: "#222222", gap: 2 }} />
    );

    const TypeSelect = ["", "Cedula", "Nit"];

    React.useEffect(() => {
        reloaduser();
    }, []);

    async function reloaduser() {
        if (getToken()) {
            const permisionCan = await can(getToken(), getCompany(), "/dashboard/com/showcompany/:id");
            if (permisionCan) {
                const company = await empresaDataAPI(getToken(), getCompany(), idCompany.id);
                const representative = await representanteempresaShow(getToken(), idCompany.id);
                const represPermisionCan = await can(getToken(), getCompany(), "/dashboard/com/createrepresentative/:id");
                setEditRepPermitido(represPermisionCan);

                setCompany(company.name);
                setCnumber(company.nit);
                setAddress(company.address);
                setPhone(company.phone);
                setWeb(company.web);
                setEmail(company.email);
                setDescription(company.description);
                setLogo(company.datos_base64);
                setCcolor(<CircleIcon sx={{ color: company.color, gap: 2 }} />);

                if (representative) {
                    setRepresentativeE(typeof representative.name !== "undefined");
                    setName(representative.name);
                    setLast(representative.lastname);
                    setDtype(TypeSelect[representative.doctype]);
                    setDnumber(representative.docnumber);
                }
                else {
                    setRepresentativeE(false);
                }
            }
            else {
                goTo("/dashboard");
            }
        }
        else {
            goTo(`/login`);
        }
    }

    return (
        <ThemeProvider theme={theme}>
            <Container maxWidth="lg" sx={{ mt: 4, mb: 4 }}>
                <Typography variant="h3" component="h1" gutterBottom align="center" sx={{ mb: 4 }}>
                    Company and Representative Information
                </Typography>

                <Grid container spacing={3}>
                    <Grid item xs={12} md={6}>
                        <Paper elevation={3} sx={{ p: 3 }}>
                            <Typography variant="h5" component="h2" gutterBottom>
                                Company Data
                            </Typography>
                            <Box display="flex" justifyContent="center" >
                                <img
                                    src={`data:image/jpeg;base64,${logo}`}
                                    alt={"Imagen"}
                                    width={200}
                                    loading="lazy"
                                />
                            </Box>
                            <List>
                                <ListItem>
                                    <ListItemText primary="Name" secondary={company} />
                                </ListItem>
                                <ListItem>
                                    <ListItemText primary="Nit" secondary={cnumber} />
                                </ListItem>
                                <ListItem>
                                    <ListItemText primary="Address" secondary={address} />
                                </ListItem>
                                <ListItem>
                                    <ListItemText primary="Phone" secondary={phone} />
                                </ListItem>
                                <ListItem>
                                    <ListItemText primary="Web" secondary={web} />
                                </ListItem>
                                <ListItem>
                                    <ListItemText primary="Email" secondary={email} />
                                </ListItem>
                                <ListItem>
                                    <ListItemText primary="Description" secondary={description} />
                                </ListItem>
                                <ListItem>
                                    <ListItemText primary="Color" secondary={ccolor} />
                                </ListItem>
                            </List>
                        </Paper>
                    </Grid>

                    <Grid item xs={12} md={6}>
                        <Paper elevation={3} sx={{ p: 3 }}>
                            <Typography variant="h5" component="h2" gutterBottom>
                                Representative Data
                            </Typography>
                            {representativeE ?
                                (

                                    <List>
                                        <ListItem>
                                            <ListItemText primary="First Name" secondary={name} />
                                        </ListItem>
                                        <ListItem>
                                            <ListItemText primary="Last Name" secondary={last} />
                                        </ListItem>
                                        <ListItem>
                                            <ListItemText primary="Document Type" secondary={dtype} />
                                        </ListItem>
                                        <ListItem>
                                            <ListItemText primary="Number" secondary={dnumber} />
                                        </ListItem>
                                        <ListItem>
                                            {editRepPermitido ? (
                                                <Button
                                                    startIcon={<PersonAddAltIcon />}
                                                    onClick={() => goTo(`/dashboard/com/createrepresentative/${idCompany.id}`)}
                                                    sx={{ mr: 1 }}
                                                >
                                                    Representative
                                                </Button>
                                            ) : (
                                                <></>
                                            )}
                                        </ListItem>
                                    </List>

                                ) : (
                                    <List>
                                        <ListItem>
                                            <Typography variant="h7" component="h2" gutterBottom>
                                                Empty
                                            </Typography>
                                        </ListItem>
                                        <ListItem>
                                            {editRepPermitido ? (
                                                <Button
                                                    startIcon={<PersonAddAltIcon />}
                                                    onClick={() => goTo(`/dashboard/com/createrepresentative/${idCompany.id}`)}
                                                    sx={{ mr: 1 }}
                                                >
                                                    Representative
                                                </Button>
                                            ) : (
                                                <></>
                                            )}
                                        </ListItem>
                                    </List>
                                )
                            }
                        </Paper>
                    </Grid>
                </Grid>
            </Container>
        </ThemeProvider>
    );
}